import _ from 'lodash'
import $ from 'jquery'

/**
 * Adds a class with the given prefix and removes any other classes with the prefix.
 *
 * Example:
 *	togglePrefixedClass($('<div class="background-none"></div>'), 'background', 'white')
 * This removes the background-none class and adds the background-white class
 */
function togglePrefixedClass (el, prefix, value) {
	var newClazz = value ? (prefix + '-' + value) : null
	var $el = $(el)

	var classes = ($el.attr('class') || '').split(' ')
	_(classes).filter(function (clazz) {
		return clazz.indexOf(prefix) === 0
	})
		.forEach(function (clazz) {
			$el.toggleClass(clazz, clazz === newClazz)
		})

	if (newClazz) {
		$el.addClass(newClazz)
	}
}

export default togglePrefixedClass

togglePrefixedClass.__filename__ = 'components/toggle-prefixed-class.js'
